module.exports = __webpack_public_path__ + "images/anwbreisverzekering04c9a89f5f5e4235bb857405a812461d.png";